import { useEffect, useRef } from "react";

const InViewVideo = ({ image, alt, className, testid }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) el.play().catch(() => {});
        else el.pause();
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <video ref={ref} poster={image.src} muted loop playsInline preload="metadata" aria-label={alt} className={className} data-testid={testid ? `${testid}-video` : undefined}>
      {image.video.map((v) => <source key={v.src} src={v.src} type={v.type} />)}
    </video>
  );
};

export const Photo = ({ image, alt, className = "", imgClassName = "", testid, eager, playInView }) => (
  <figure className={`${className.includes("absolute") ? "" : "relative"} overflow-hidden bg-heritage-deep ${className}`} data-testid={testid}>
    {image.video && playInView ? (
      <InViewVideo image={image} alt={alt} className={`h-full w-full object-cover ${imgClassName}`} testid={testid} />
    ) : image.video ? (
      <video poster={image.src} autoPlay muted loop playsInline preload="metadata" aria-label={alt} className={`h-full w-full object-cover ${imgClassName}`} data-testid={testid ? `${testid}-video` : undefined}>
        {image.video.map((v) => <source key={v.src} src={v.src} type={v.type} />)}
      </video>
    ) : (
    <img
      src={image.src}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      className={`h-full w-full object-cover ${imgClassName}`}
    />
    )}
  </figure>
);
